import styled from "styled-components";

export const Division = styled.div`
    .search-font{
        position: absolute;
        right: 10px;
        top: 51%;
        transform: translateY(-50%);
    }
`